// extracted by mini-css-extract-plugin
export default {"header":"styles_header__yiS9l"};